document.addEventListener('alpine:init', () => {
  Alpine.data('countryShuffleHero', () => ({
    countries: [],
    country: {},

    init() {
      this.$nextTick(() => {
        this.countries = JSON.parse(this.$refs.countries.innerHTML);

        if (this.countries && this.countries.length) {
          this.$refs.headline.innerHTML = this.$refs.headline.innerHTML.replace(
            /\*countries\*/g,
            '<span x-ref="countryName"></span>'
          );

          setTimeout(() => {
            writeAndDelete(
              this.$refs.countryName,
              this.countries.map((c) => c.name),
              {
                timeout: 2200,
                loop: true,
                speed: 150,
                errorQuota: 0,
                cursor: '|',
                cursorSpeed: 500,
              }
            );
          });
        }
      });
    },

    changeImage(event) {
      this.index = +event.detail;
      this.country = this.countries[this.index];
    },

    image: {
      ':style'() {
        return {
          backgroundImage: `url(${this.c.image})`,
          opacity: this.c.name === this.country?.name ? 1 : 0,
        };
      },
    },
  }));
});